
import React from 'react';

export default class HomeLogo extends React.Component {
    render () {
        var classes = ["toplogo"];

        return <img className={classes.join(' ')} src="img/en_top_img.png"></img>
    }
};
